import React from 'react';
import { Button, ButtonGroup, Form } from 'react-bootstrap';
import { Calendar, ChevronDown, ChevronUp, List, Trello } from 'react-feather';
import { connect } from 'react-redux';
import HkTooltip from '../../../components/@hk-tooltip/HkTooltip';
import { toggleTopNav } from '../../../redux/action/Theme';

const PipelineHeader = ({ topNavCollapsed, toggleTopNav, addNewDeal }) => {
    return (
        <header className="taskboard-header">
            <div className="d-flex align-items-center flex-1">
                <a className="taskboardapp-title link-dark" href="#some">
                    <h1>
                        Collections Pipeline
                    </h1>
                </a>
                <Button variant="primary" className="ms-3 d-xxl-inline-block d-none flex-shrink-0" onClick={addNewDeal}>Add A/R</Button>
                <ButtonGroup className="d-xxl-inline-flex d-none mx-3">
                    <Button variant="outline-light" className="btn-icon">
                        <span className="icon">
                            <span className="feather-icon"><Trello />
                            </span>
                        </span>
                    </Button>
                    <Button variant="outline-light" className="btn-icon">
                        <span className="icon">
                            <span className="feather-icon">
                                <List />
                            </span>
                        </span>
                    </Button>
                    <Button variant="outline-light" className="btn-icon">
                        <span className="icon">
                            <span className="feather-icon">
                                <Calendar />
                            </span>
                        </span>
                    </Button>
                </ButtonGroup>
            </div>
            <div className="d-md-flex flex-shrink-0 mx-3 d-none">
                <div className="d-flex align-items-center">
                    <span className="d-md-inline d-none">A/R Balance:</span>
                    <span className="text-dark fs-5 fw-medium ps-2">$233,706</span>
                </div>
                <div className="v-separator" />
                <div className="d-flex align-items-center">
                    <span className="d-md-inline d-none">A/R Overdue:</span>
                    <span className="text-dark fs-5 fw-medium ps-2">$100,000</span>
                </div>
            </div>
            <div className="taskboard-options-wrap flex-1 justify-content-end">
                <Form className="leave-search  d-lg-inline-block d-none" role="search">
                    <Form.Control type="text" placeholder="Search cards" />
                </Form>
                <Button as="a" variant="flush-dark" className="btn-icon btn-rounded flush-soft-hover hk-navbar-togglable d-sm-inline-block d-none" onClick={() => toggleTopNav(!topNavCollapsed)} >
                    <HkTooltip placement={topNavCollapsed ? "bottom" : "top"} title="Collapse" >
                        <span className="icon">
                            <span className="feather-icon">
                                {
                                    topNavCollapsed ? <ChevronDown /> : <ChevronUp />
                                }
                            </span>
                        </span>
                    </HkTooltip>
                </Button>
            </div>
        </header>
    )
}

const mapStateToProps = ({ theme }) => {
    const { topNavCollapsed } = theme;
    return { topNavCollapsed }
};

export default connect(mapStateToProps, { toggleTopNav })(PipelineHeader);